export const mapboxStyles = {
  en: 'mapbox://styles/eventinc/ckue1uxrs1t0x18ohtnbskiew',
  de: 'mapbox://styles/eventinc/ckue2g4f18rkz17o39ci104b0',
}

const mapboxStyle = (locale) => mapboxStyles[locale.substr(0, 2).toLowerCase()] || mapboxStyles.de

export default mapboxStyle
